/**
 * created by lei lei on 2020/6/20
 * 媒体管理页面
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import {Col, Radio} from "antd";
import MyMedia from './MyMedia'
import MyApplication from './MyApplication'
import PageScrollBars from "../components/pageScrollBars/PageScrollBars";

export default class MediaManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            mediaType: 1,

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

//点击按钮
    handleTextChange = e => {
        this.setState({mediaType: e.target.value});
    };

    render() {
        return (
            <PageScrollBars content={
                <div className={'MediaManagement'}>
                   {/* <div style={{display: 'flex',}}>
                        <Radio.Group style={{marginLeft: 20, marginTop: 20}} value={this.state.mediaType}
                                     onChange={this.handleTextChange}>
                            <Radio.Button value={1}>我的媒体</Radio.Button>
                            <Radio.Button value={2}>我的申请</Radio.Button>
                        </Radio.Group>
                    </div>*/}
                    <div style={{width: '100%', padding: 20}}>
                        {
                            this.state.mediaType === 1 ? <MyMedia/> : <MyApplication/>
                        }
                    </div>
                </div>
            }/>


        )
    }

}